module.exports = __webpack_public_path__ + "img/worker.683accc3.jpg";